import * as RadixSelect from '@radix-ui/react-select'
import { styled } from '../../../config'

export const ContentPrimitive = styled(RadixSelect.Content, {
  overflow: 'hidden',
  minHeight: 0,
  maxHeight: '300px !important',
  backgroundColor: '$white',
  width: '100% !important',
  borderRadius: '$6',
  boxShadow:
    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
  variants: {
    variant: {
      dark: {
        borderColor: '#505050',
        backgroundColor: '#3E3E3E'
      }
    }
  }
})
